export const rightPanelClassName = 'transfer-account-tutorial_right-panel';
export const leftPanelClassName = 'transfer-account-tutorial_left-panel';
export const buttonToLeftClassName = 'transfer-account-tutorial_button-to-left';
export const buttonToRightClassName = 'transfer-account-tutorial_button-to-right';
